import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const sendCodeToChangeEmail = async (email) => {
  try {
    const response = await client.post(
      '/Profile/email',
      {},
      {
        headers: authHeader(),
        params: { email },
      }
    );
    if (response.data.result === 'Error') {
      message.error(response.data.message, 5);
      return false;
    }
    return true;
  } catch (e) {
    console.error(e);
    message.error('Произошла ошибка', 5);
    return false;
  }
};

export default sendCodeToChangeEmail;
